import React, { useState, useEffect } from 'react';
import './Hero.css';

const heroImages = [
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
  "https://images.unsplash.com/photo-1611892440504-42a792e24d32?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
  "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
];

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % heroImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const handleBookNow = () => {
    // Add your booking logic here
    console.log('Book Now clicked');
  };

  const handleExploreRooms = () => {
    // Add your explore rooms logic here
    console.log('Explore Rooms clicked');
  };

  return (
    <section className="hero" aria-label="Hero section">
      <div 
        className="hero-image" 
        style={{ backgroundImage: `url(${heroImages[currentImage]})` }}
        role="img"
        aria-label="Luxury hotel interior"
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Welcome to Golden Nest</h1>
            <p>Experience Luxury Like Never Before</p>
            <div className="hero-buttons">
              <button 
                className="btn-primary" 
                onClick={handleBookNow}
                aria-label="Book your stay"
              >
                Book Your Stay
              </button>
              <button 
                className="btn-secondary" 
                onClick={handleExploreRooms}
                aria-label="Explore our rooms"
              >
                Explore Rooms
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <button 
        className="slider-btn prev" 
        onClick={prevImage}
        aria-label="Previous image"
      >
        ‹
      </button>
      <button 
        className="slider-btn next" 
        onClick={nextImage}
        aria-label="Next image"
      >
        ›
      </button>
      
      <div className="slider-dots" role="tablist" aria-label="Image slider dots">
        {heroImages.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentImage ? 'active' : ''}`}
            onClick={() => setCurrentImage(index)}
            aria-label={`Go to image ${index + 1}`}
            aria-selected={index === currentImage}
            role="tab"
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;